<script lang="ts">
    import { Icon, Input, Popover } from "sveltestrap";
    import AppWraper from "../components/AppWraper.svelte";
    import { diligencesService, recordsCitationService, recordsDetainedService, recordsExternalBackgroundService, recordsIntoOutService, recordsLostObjectsService, recordsUnidentifiedPerson, thirdsService, vehiclesService } from "../services";

    let searchFilterComponent = {
        date : null
    };

    let startDate = null;
    let endDate = null;
  
    let date = new Date();

    let diligencesQuantity = 0
    let registersQuantity = 0
    let externalAntecedentsQuantity = 0
    let detainedQuantity = 0
    let lostQuantity = 0
    let unidentifiedQuantity = 0
    let thirds = 0
    let vehicles = 0

    loadInputDate();

    async function getStats() {
        ;

        let opts = {
            filters : {
                search: JSON.stringify(searchFilterComponent)
            }
        }

        diligencesQuantity = await diligencesService.getDiligencesQuantity(opts);
        let citationsQuantity = await recordsCitationService.getRecordsQuantity(opts);
        registersQuantity = await recordsIntoOutService.getRecordsQuantity(opts) + citationsQuantity;
        detainedQuantity = await recordsDetainedService.getRecordsQuantity(opts);
        externalAntecedentsQuantity = await recordsExternalBackgroundService.getRecordsQuantity(opts);
        lostQuantity = await recordsLostObjectsService.getRecordsQuantity(opts);
        unidentifiedQuantity = await recordsUnidentifiedPerson.getRecordsQuantity(opts);
        thirds = await thirdsService.getQuantity(opts);
        vehicles = await vehiclesService.getQuantity(opts);
    }

    async function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        let day = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()

        if (date.getDate() < 10 ) {
            day += date.getDate();
        } else {
            day = `${date.getDate()}`;
        }
        

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];

        searchFilterComponent.date = selectedDates;

        await getStats()
    }

    async function replaceDate() {
            let popover = document.getElementById('popover');
            popover.hidden = true;
        
        let selectedDates = [startDate, endDate];
        searchFilterComponent.date = selectedDates;

        await getStats()
    }

    function clearFilter() {
        searchFilterComponent = {
            date : null
        };

        loadInputDate();
    }
</script>


<AppWraper>
    <div class="pt-3 mt-4">
        <div class="container">
            <div class="p-3 mb-4 rounded-3">
                <div class="container-fluid py-5 d-flex justify-content-between">
                    <h1 class="display-5 fw-bold">Panel de control</h1>

                    <div class="mb-3 d-flex justify-content-end">
                        <button class='btn border border-dark' id='pop'>
                            {startDate} - {endDate}
                        </button>
                        <Popover placement="bottom" target="pop" id='popover'>
                            <div id='startDate'>
                                <p>Desde:</p>
                                <Input
                                    type='date'
                                    bind:value={startDate}
                                />
                            </div>
                            <div id='endDate'>
                                <p>Hasta</p>
                                <Input
                                    type='date'
                                    bind:value={endDate}
                                />
                            </div>
                            <button class='btn btn-primary mt-3' on:click={replaceDate}>Buscar</button>
                        </Popover>
            
                        <button class='btn btn-primary ms-1' on:click={clearFilter}><Icon name='eraser' /></button>
                    </div>
                </div>
            </div>
            <div class='row p-3'>
                <div class='col-md-4 col-sm-6 p-2'>
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class='p-3 d-flex justify-content-center align-items-center me-3'>
                                <span class='fs-3 text-primary fw-bold'><Icon name='person' /></span>
                            </div>
                            <div class='d-flex flex-column'>
                                <span class='fs-5'>Terceros</span>
                                <span class='fs-2 fw-bold'>{thirds}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='col-md-4 col-sm-6 p-2'>
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class='p-3 d-flex justify-content-center align-items-center me-3'>
                                <span class='fs-3 text-primary fw-bold'><Icon name='truck' /></span>
                            </div>
                            <div class='d-flex flex-column'>
                                <span class='fs-5'>Vehículos</span>
                                <span class='fs-2 fw-bold'>{vehicles}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span class='fs-3 fw-bold'>Registros</span>
            <div class='row p-3'>
                <div class='col-md-4 col-sm-6 p-2'>
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class='p-3 d-flex justify-content-center align-items-center me-3'>
                                <span class='fs-3 text-primary fw-bold'><Icon name='file-text' /></span>
                            </div>
                            <div class='d-flex flex-column'>
                                <span class='fs-5'>Diligencias</span>
                                <span class='fs-2 fw-bold'>{diligencesQuantity}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='col-md-4 col-sm-6 p-2'>
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class='p-3 d-flex justify-content-center align-items-center me-3'>
                                <span class='fs-3 text-primary fw-bold'><Icon name='file-text' /></span>
                            </div>
                            <div class='d-flex flex-column'>
                                <span class='fs-5'>Registros</span>
                                <span class='fs-2 fw-bold'>{registersQuantity}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='col-md-4 col-sm-6 p-2'>
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class='p-3 d-flex justify-content-center align-items-center me-3'>
                                <span class='fs-3 text-primary fw-bold'><Icon name='file-text' /></span>
                            </div>
                            <div class='d-flex flex-column'>
                                <span class='fs-5'>Ant. Externos</span>
                                <span class='fs-2 fw-bold'>{externalAntecedentsQuantity}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='col-md-4 col-sm-6 p-2'>
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class='p-3 d-flex justify-content-center align-items-center me-3'>
                                <span class='fs-3 text-primary fw-bold'><Icon name='file-text' /></span>
                            </div>
                            <div class='d-flex flex-column'>
                                <span class='fs-5'>Detenidos</span>
                                <span class='fs-2 fw-bold'>{detainedQuantity}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='col-md-4 col-sm-6 p-2'>
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class='p-3 d-flex justify-content-center align-items-center me-3'>
                                <span class='fs-3 text-primary fw-bold'><Icon name='file-text' /></span>
                            </div>
                            <div class='d-flex flex-column'>
                                <span class='fs-5'>Obj. Perdidos</span>
                                <span class='fs-2 fw-bold'>{lostQuantity}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='col-md-4 col-sm-6 p-2'>
                    <div class="card">
                        <div class="card-body d-flex">
                            <div class='p-3 d-flex justify-content-center align-items-center me-3'>
                                <span class='fs-3 text-primary fw-bold'><Icon name='file-text' /></span>
                            </div>
                            <div class='d-flex flex-column'>
                                <span class='fs-5'>Sin identificar</span>
                                <span class='fs-2 fw-bold'>{unidentifiedQuantity}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</AppWraper>

<style>
    .card {
        max-width: 100%;
        width: 300px;
        min-width: 150px;
        height: 100%;
    }
</style>